import Typography from './data-display/Typography';
import Avatar from './data-display/Avatar';
import Table from './data-display/Table';
import DataGrid from './mui-x/DataGrid';
import Snackbar from './feedback/Snackbar';
import SnackbarContent from './feedback/SnackbarContent';
import Button from './inputs/Button';
import TextField from './inputs/TextField';
import OutlinedInput from './inputs/OutlinedInput';
import FloatingActionButton from './inputs/FloatingActionButton';
import InputLabel from './inputs/InputLabel';
import Container from './layout/Container';
import Divider from './layout/Divider';
import Drawer from './navigation/Drawer';
import Link from './navigation/Link';
import Paper from './surfaces/Paper';

export default {
	MuiTypography: Typography,
	MuiAvatar: Avatar,
	MuiSnackbar: Snackbar,
	MuiSnackbarContent: SnackbarContent,
	MuiButton: Button,
	MuiTextField: TextField,
	MuiOutlinedInput: OutlinedInput,
	MuiFab: FloatingActionButton,
	MuiInputLabel: InputLabel,
	MuiContainer: Container,
	MuiDivider: Divider,
	MuiDrawer: Drawer,
	MuiLink: Link,
	MuiPaper: Paper,
	MuiDataGrid: DataGrid,
	MuiTable: Table,
};
